import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '@/components/ui/table';
import { mockPapers, mockUsers, mockGroups } from './mockData';
import { cn } from '@/lib/utils';

const statusConfig: Record<string, { label: string; class: string }> = {
  draft: { label: 'Entwurf', class: 'bg-muted text-muted-foreground' },
  in_review: { label: 'In Review', class: 'bg-primary/10 text-primary' },
  reviewed: { label: 'Reviewed', class: 'bg-amber-500/10 text-amber-700 dark:text-amber-400' },
  submission_ready: { label: 'Einreichungsreif', class: 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400' },
};

const PaperOverviewTab = () => {
  const userMap = Object.fromEntries(mockUsers.map((u) => [u.id, u.name]));
  const groupMap = Object.fromEntries(mockGroups.map((g) => [g.id, g.name]));
  const userGroupMap = Object.fromEntries(mockUsers.map((u) => [u.id, u.groupId]));

  return (
    <div className="rounded-xl border border-border/50 overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Titel</TableHead>
            <TableHead>Autor</TableHead>
            <TableHead>Gruppe</TableHead>
            <TableHead className="text-right">Versionen</TableHead>
            <TableHead className="text-right">Score</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {mockPapers.map((p) => {
            const s = statusConfig[p.status];
            const gId = p.groupId ?? userGroupMap[p.authorId];
            return (
              <TableRow key={p.id}>
                <TableCell className="max-w-[280px]">
                  <p className="font-medium truncate">{p.title}</p>
                </TableCell>
                <TableCell className="text-sm">{userMap[p.authorId] ?? '—'}</TableCell>
                <TableCell className="text-sm text-muted-foreground">
                  {gId ? groupMap[gId] ?? '—' : '—'}
                </TableCell>
                <TableCell className="text-right font-medium">v{p.versions}</TableCell>
                <TableCell className="text-right">
                  {p.latestReviewScore !== null ? (
                    <span
                      className={cn(
                        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold',
                        p.latestReviewScore >= 7.5
                          ? 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400'
                          : p.latestReviewScore >= 5
                            ? 'bg-amber-500/10 text-amber-700 dark:text-amber-400'
                            : 'bg-destructive/10 text-destructive'
                      )}
                    >
                      {p.latestReviewScore.toFixed(1)}
                    </span>
                  ) : (
                    <span className="text-muted-foreground text-xs">—</span>
                  )}
                </TableCell>
                <TableCell>
                  <span className={cn('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', s.class)}>
                    {s.label}
                  </span>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default PaperOverviewTab;
